export default __webpack_public_path__ + "static/media/important.705efe4a.svg";